/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_How_Real_DescInputs */



/**
* | output |
* | --- |
* | "Besides the practice conversations, you can also use Wundo to prepare your real ones. Take the coming weeks to discover how Wundo helps you with that." |
*
* @param {Onboarding_Pilot_How_Real_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_how_real_desc = /** @type {((inputs?: Onboarding_Pilot_How_Real_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_How_Real_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Naast de oefengesprekken kan je Wundo ook inzetten om je echte gesprekken voor te bereiden. Ontdek de komende weken gerust hoe Wundo je daarbij helpt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("En plus des entretiens d’entraînement, vous pouvez aussi utiliser Wundo pour préparer vos vraies conversations. Profitez des semaines à venir pour découvrir comment Wundo vous y aide.")
	return /** @type {LocalizedString} */ ("Besides the practice conversations, you can also use Wundo to prepare your real ones. Take the coming weeks to discover how Wundo helps you with that.")
});